import React from 'react'

import { Formik } from 'formik'

import { ZariContext } from '_zari/context'
import { Button, Form, Card, Col, Row } from '_zari/core'

import * as SocioService from 'services/socio.service'

import * as FormGroups from './formGroups'
import { ValidationSchema } from './validation'

const CrearEditarContactoSection = ({ idSocio, editarData, refrescarTabla, refrescarSection }) => {
  const __zariContext = React.useContext(ZariContext)

  const formInitialValues = React.useMemo(
    () => ({
      nombre: editarData.nombre || '',
      telefono1: editarData.telefono1 || '',
      telefono2: editarData.telefono2 || '',
      email1: editarData.email1 || '',
      email2: editarData.email2 || '',
      comentario: editarData.comentario || ''
    }),
    [editarData]
  )

  const submitHandler = React.useCallback(
    data => {
      const promiseAction = editarData._id
        ? () => SocioService.actualizarContactoxIdSocioxIdContacto(idSocio, editarData._id, data)
        : () => SocioService.nuevoContactoxIdSocio(idSocio, data)

      promiseAction()
        .then(({ data }) => {
          __zariContext.toast('success', editarData._id ? 'El contacto se ha actualizado.' : 'El contacto se ha creado.')
          refrescarTabla()
          refrescarSection()
        })
        .catch(({ data: { error } }) => __zariContext.toast('error', error))
    },
    [__zariContext, editarData, refrescarTabla, refrescarSection, idSocio]
  )

  return (
    <Card>
      <Card.Header>{editarData._id ? 'Editar Contacto' : 'Nuevo Contacto'}</Card.Header>
      <Card.Body>
        <Formik initialValues={formInitialValues} onSubmit={submitHandler} validationSchema={ValidationSchema}>
          {({ errors, handleSubmit, isSubmitting, setValues, touched, values }) => (
            <Form>
              <FormGroups.NombreFormGroup iError={errors.nombre} iTouched={touched.nombre} fIsSubmitting={isSubmitting} />
              <FormGroups.Telefono1FormGroup iError={errors.telefono1} iTouched={touched.telefono1} fIsSubmitting={isSubmitting} />
              <FormGroups.Telefono2FormGroup iError={errors.telefono2} iTouched={touched.telefono2} fIsSubmitting={isSubmitting} />
              <FormGroups.Email1FormGroup iError={errors.email1} iTouched={touched.email1} fIsSubmitting={isSubmitting} />
              <FormGroups.Email2FormGroup iError={errors.email2} iTouched={touched.email2} fIsSubmitting={isSubmitting} />
              <FormGroups.ComentarioFormGroup iError={errors.comentario} iTouched={touched.comentario} fIsSubmitting={isSubmitting} />
              <Row className='mt-2'>
                <Col md={12} className='text-right'>
                  <Button color='secondary' onClick={refrescarSection}>
                    Cancelar
                  </Button>
                  <Button onClick={handleSubmit}>{editarData._id ? 'Actualizar' : 'Crear'}</Button>
                </Col>
              </Row>
            </Form>
          )}
        </Formik>
      </Card.Body>
    </Card>
  )
}

export default React.memo(CrearEditarContactoSection)
